import React from "react";
import "./RotatingText.scss";
import { ReactComponent as RoundText } from '../../../assets/images/round-text.svg';

const RotatingText = ({ inverted }) => {
  return <RoundText className={`RotatingText ${inverted ? "inverted" : ""}`} />
}

export default RotatingText;
